import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let solutionsSection = document.querySelector('.solutions');

if(solutionsSection) {
    solutionInit();
}


function solutionInit() {
    let solutionsItems = document.querySelectorAll(".solutions__item");
    solutionsItems.forEach((item) => {
        let solutionsIcon = item.querySelector('.solutions__icon');
        let solutionsText = item.querySelector('.solutions__content');
        let animationIcon = gsap.timeline({
            scrollTrigger: {
                trigger: solutionsIcon,
                start: "top 95%",
                toggleActions: "play none none reverse",
                // markers: true,
            }
        });
        let animationText = gsap.timeline({
            scrollTrigger: {
                trigger: solutionsIcon,
                start: "top 95%",
                toggleActions: "play none none reverse",
                // markers: true,
            }
        });

        animationIcon.fromTo(solutionsIcon, {
                opacity: 0,
                rotationY: 90,
                ease: "Back.easeOut"
            },
            {
                // y: 0,
                opacity: 1,
                rotationY: 0,
                delay: .2,
                duration: .8,
                ease: "Back.easeOut"
            });

        animationText.fromTo(solutionsText, {
                opacity: 0,
                ease: "Back.easeOut"
            },
            {
                opacity: 1,
                delay: .2,
                duration: .8,
                ease: "Back.easeOut"
            });
    });
}